export class Publishing {
  constructor(publishing, urlPublishing, imagePublishing) {
    this.publishing = publishing;
    this.urlPublishing = urlPublishing;
    this.imagePublishing = imagePublishing;
  }
}
